import { render, staticRenderFns } from "./ServiceTutorEditTutorPersonalDetails.vue?vue&type=template&id=b155512c&scoped=true&"
import script from "./ServiceTutorEditTutorPersonalDetails.vue?vue&type=script&lang=js&"
export * from "./ServiceTutorEditTutorPersonalDetails.vue?vue&type=script&lang=js&"
import style0 from "./ServiceTutorEditTutorPersonalDetails.vue?vue&type=style&index=0&id=b155512c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b155512c",
  null
  
)

export default component.exports